export default {
  pending: "pending",
  open: "open",
  success: "success",
  cancelled: "cancelled",
  error: "error",
  failure: "failure"
}
